var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    width: "32px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.961,13.322C27.225,11.907,28,10.046,28,8c0-4.418-3.582-8-8-8s-8,3.582-8,8c-4.418,0-8,3.582-8,8  c0,2.046,0.775,3.907,2.039,5.322C2.381,23.076,0,26.378,0,30c0,1.078,0.844,2,2,2h20c1.156,0,2-0.922,2-2  c0-2.215-0.898-4.306-2.427-6H30c1.156,0,2-0.922,2-2C32,18.378,29.619,15.076,25.961,13.322z M20,4c2.209,0,4,1.791,4,4  s-1.791,4-4,4c-0.422,0-0.821-0.083-1.203-0.205c-0.652-1.052-1.54-1.939-2.592-2.592C16.083,8.821,16,8.422,16,8  C16,5.791,17.791,4,20,4z M12,12c2.209,0,4,1.791,4,4s-1.791,4-4,4s-4-1.791-4-4S9.791,12,12,12z M4.494,28  C5.569,25.835,8.32,24,12,24s6.431,1.835,7.506,4H4.494z M18.914,20C19.6,18.823,20,17.46,20,16c3.68,0,6.431,1.835,7.506,4H18.914z  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.003c7b793bf3cf9006a9ba6ea1494d5a.svg";
export { ForwardRef as ReactComponent };